import React, { useState, useEffect } from "react";

const StatusDetails = ({
  id,
  isStatusDetailsOpen,
  closeStatusDetails,
  selectedOption,
  setSelectedOption,
  openOverrideGuarantor,
  openReasonsForOverriding,
  selectedGuarantor,
}) => {
  const [isInputsFilled, setIsInputsFilled] = useState(false);

  
  useEffect(() => {
    if (selectedGuarantor?.status) {
      setSelectedOption(selectedGuarantor?.status);
      setIsInputsFilled(true);
    }
  }, [selectedGuarantor, setSelectedOption]);

  const handleBackButtonClick = () => {
    closeStatusDetails();
    openOverrideGuarantor();
  };

  const handleOptionChange = (event) => {
    setSelectedOption(event.target.value);
    setIsInputsFilled(true);
  };

  const handleNextButtonClick = () => {
    closeStatusDetails();
    openReasonsForOverriding();
  };

  return (
    <>
      <div
        id={id}
        className={`${
          isStatusDetailsOpen ? "flex" : "hidden"
        } items-center justify-center fixed inset-0 z-50 overflow-auto bg-gray-800 bg-opacity-50`}
      >
        <div className="relative flex items-center fixed min-h-screen w-[58%] max-w-[100%] h-full md:h-auto">
          <div className="relative justify-end bg-white shadow w-[100%] mx-auto h-[95vh] px-6">
            <div className="justify-end rounded-t flex items-end">
              <button
                onClick={closeStatusDetails}
                type="button"
                className="bg-transparent rounded-lg text-sm p-2.5 ml-auto inline-flex items-center"
                data-modal-toggle="modal"
              >
                <svg
                  width="12"
                  height="12"
                  viewBox="0 0 12 12"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M7.84 12L5.7 8.9L3.9 12H0.2L3.88 6.3L0.1 0.839999H3.94L6.08 3.92L7.88 0.839999H11.58L7.84 6.46L11.68 12H7.84Z"
                    fill="black"
                  />
                </svg>
              </button>
            </div>
            <div className="w-[95%]">
              <div className="mt-10 mx-auto items-center">
                <p className="text-[#000] text-xl font-bold">
                  Override Guarantorship Status Details
                </p>
                <div className="text-[#000] mt-2 mb-[10px] text-[15px] font-[300]">
                  <p>
                    Adjust the guarantorship status for{" "}
                    <span className="font-bold text-[#06B217]">
                      {selectedGuarantor?.name
                        ?.split(" ")
                        .map(
                          (nam) =>
                            nam?.charAt(0)?.toUpperCase() +
                            nam?.slice(1)?.toLowerCase()
                        )
                        .join(" ")}
                    </span>{" "}
                    [
                    {
                      <span className="font-bold text-[#06B217]">
                        {selectedGuarantor?.memberID}
                      </span>
                    }
                    ]. Ensure this change aligns with the loan requirements and
                    note that the guarantor will be notified immediately upon
                    confirmation.
                  </p>
                </div>
              </div>
              <div className="font-poppins font-light italic text-[15px] leading-[22.5px] tracking-normal mt-8">
                Select New Guarantorship Status
              </div>
              <div className="flex justify-center">
                <div className="overflow-y-auto border border-1 border-[#000000] gap-[20px] flex flex-col p-[20px] w-[840px] rounded-[5px]">
                  {["pending", "accepted", "rejected"].map((reason) => (
                    <div className="flex items-center gap-[10px]" key={reason}>
                      <input
                        type="radio"
                        value={reason}
                        checked={selectedOption === reason}
                        onChange={handleOptionChange}
                        className="mr-2 h-4 w-4"
                      />
                      <label>{reason}</label>
                    </div>
                  ))}
                </div>
              </div>
            </div>

            <div className="flex items-end justify-between w-[95%] h-[25vh] mt-5">
              <button
                onClick={handleBackButtonClick}
                data-modal-toggle={id}
                type="button"
                className="text-[#005C53] font-[500] rounded-[5px] text-[16px] px-10 py-2 text-center bg-[#8ED6A8]"
              >
                Back
              </button>

              <button
                onClick={handleNextButtonClick}
                type="button"
                className={`text-white ${
                  isInputsFilled
                    ? "bg-[#005C53] hover:bg-[#005C53] focus:outline-none"
                    : "bg-[#D9D9D9] pointer-events-none"
                } block rounded-[5px] text-[16px] font-[500] px-8 py-2.5 text-center`}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default StatusDetails;
